import React, { useEffect, useRef, useState } from 'react'
import { Box, Drawer,Input, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay, Heading, IconButton, Image, Text } from '@chakra-ui/react'
import CloseIcon from '../../../../../assets/images/close-side.svg'
import PartialIcon from '../../../../../assets/images/partialpay.svg'
import CustomButton from '../../../../elements/customButton'
import moment from 'moment'
import CustomToast from '../../../../elements/customToast'
export default function ActiveLoanSidebar(props) {
    const [disablePaybtn, setDisblePaybtn] = useState(false)
    const { addToast } = CustomToast()
    const [userPartialPayment, setUserPartialPayment] = useState({ user_enter_amount: "" })
    const [disablePartialbtn, setDisablePartialbtn] = useState(true)
    const [showParentPartial, setShowParentPartial] = useState(true)
    const inputRef = useRef(null);
    const [showDialoagPartial, setShowDialoagPartial] = useState(false)
    const loanContractId = props?.data?.loanContract[0]?.id
    const repaymentDate = props?.data?.maturity_date && moment(props?.data?.maturity_date).format("DD-MM-YYYY")
    const emiStartDate = props?.data?.loanContract[0]?.emi_date && moment(props?.data?.loanContract[0]?.emi_date).format("DD-MM-YYYY")
    const emiEndDate = props?.data?.maturity_date && moment(props?.data?.maturity_date).format("DD-MM-YYYY")
    const interestAmount = (props?.data?.payment_frequency === 0) ? props?.data?.loanContract[0]?.accured_interset_on_emi : props?.data?.loanContract[0]?.accured_interset_till_date
    const emiAmount = props?.data?.loanContract[0]?.payment_amount
    const totalOutstandingAmount = props?.data?.loanContract[0]?.total_outstanding_dues
    const totalEmiPayAmount = props?.data?.loanContract[0]?.penel_interset_till_date > 0 && props?.data?.loanContract[0]?.accured_interset_till_date > 0 ? props?.data?.loanContract[0]?.total_outstanding_dues : props?.data?.loanContract[0]?.outstanding_amount
    const EmipayoutAmnt = props?.data?.loanContract[0]?.total_outstanding_dues > 0 ? props?.data?.loanContract[0]?.total_outstanding_dues : props?.data?.loanContract[0]?.outstanding_amount
    const penalInterest = props?.data?.loanContract[0]?.penel_interset_till_date
    const isPartPay = props?.data?.part_payment
    const isRepaymentActive = props?.data?.loanContract[0]?.disbursal?.[0]?.is_repayment_active === 1
    const forcloseActive = props?.data?.is_foreclosure_active
    const pay_emi_btn = props?.data?.payment_frequency
    useEffect(() => {
if(props?.data?.loanContract[0]?.disbursal?.[0]?.is_repayment_active == 0) {
            setDisblePaybtn(true)
        }
    }, [props?.data])
    useEffect(() => {
        setDisablePartialbtn(userPartialPayment.user_enter_amount.trim() === "");
    }, []);
    const handleChange = (e) => {
        let { value, name } = e.target;
        if (String(value).includes(".")) {
            return;
        }
        if (parseFloat(value) > totalOutstandingAmount) {
            addToast({ message: "Please Enter Valid Amount", status: 'error' });
        }
        setUserPartialPayment((prev) => ({
            ...prev,
            [name]: value === "" ? "" : parseInt(value, 10)
        }));
        const numericValue = parseFloat(value);
        setDisablePartialbtn(
            value.trim() === "" || isNaN(numericValue) || numericValue <= 0 || numericValue > totalOutstandingAmount
        )}
        let handleOpenPartialDialog =()=>{
            setShowDialoagPartial(!showDialoagPartial)
            setShowParentPartial(false)
        }
    const PopupBox = () => (
        <Box>
            <DrawerOverlay />
            <DrawerContent>
                <Box className="actions_group">
                    <IconButton onClick={props.handleCloseSidebar} className="btn_close_sidebar" icon={<Image src={CloseIcon} />} />
                </Box>
                <DrawerHeader className='sidebar_header'>
                    <Box className='loan_type_heading d-flex align-items-center'>
                        <Heading as="h5" className='font-poppins'>Loan Application ID</Heading>
                        <Text className={props?.data?.product_id === 3 ? "font-poppins table_text loan_insta" :
                            props?.data?.product_id === 1 ? "font-poppins table_text loan_personal" :
                                (props?.data?.product_id === 2 || props?.data?.product_id === 17) ? "font-poppins table_text loan_bullet" :
                                    "font-poppins table_text"} >
                            {props?.data?.loan_name}
                        </Text>
                    </Box>
                    <Heading as="h4" className='font-poppins'>{props?.data?.loan_number}</Heading>
                </DrawerHeader>
                <DrawerBody>
                    <Box className='sidebar_body_top'>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Loan Status </Heading>
                            <Text className='font-poppins'>{props?.data?.loan_status === "Closing Underprocess" ? props?.data?.loan_status : 'Active'}</Text>
                        </Box>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Loan Amount</Heading>
                            <Text className='font-poppins'>₹ {props?.data?.loanContract[0]?.pledged_amount}</Text>
                        </Box>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Disbursed Date</Heading>
                            <Text className='font-poppins'>{props?.data?.loanContract[0]?.disbursal[0]?.disbursal_date && moment(props?.data?.loanContract[0]?.disbursal[0]?.disbursal_date).format("DD-MM-YYYY")}</Text>
                        </Box>
                        {props?.data?.payment_frequency === 0 ?
                            <>
                                <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                                    <Heading as="h6" className='font-poppins'>EMI Amount</Heading>
                                    <Text className='font-poppins'>₹ {emiAmount}</Text>
                                </Box>
                                {emiStartDate &&
                                    <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                                        <Heading as="h6" className='font-poppins'>Upcoming EMI Date</Heading>
                                        <Text className='font-poppins'>{emiStartDate}</Text>
                                    </Box>
                                }
                                <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                                    <Heading as="h6" className='font-poppins'>EMI End Date</Heading>
                                    <Text className='font-poppins'>{emiEndDate}</Text>
                                </Box>
                            </> :
                            <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                                <Heading as="h6" className='font-poppins'>Repayment Date</Heading>
                                <Text className='font-poppins'>{repaymentDate}</Text>
                            </Box>
                        }
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Tenure</Heading>
                            <Text className='font-poppins'>{props?.data?.tenure_duration}</Text>
                        </Box>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Interest Rate</Heading>
                            <Text className='font-poppins'>{props?.data?.product_id === 3 ? " 0.2% Per Day (73% p.a)" : props?.data?.interest_rate + " % Per Annum"}</Text>
                        </Box>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Interest Amount (Till Date)</Heading>
                            <Text className='font-poppins'>₹ {interestAmount}</Text>
                        </Box>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Penal Interest Amount</Heading>
                            <Text className='font-poppins'>₹ {penalInterest}</Text>
                        </Box>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                    <Heading as="h6" className='font-poppins'>Recovery Amount</Heading>
                            <Text className='font-poppins f-600'>₹ {props?.data?.loanContract[0]?.recovery_amount} </Text>
                    </Box>
                        <Box className='loan_data_box d-flex align-items-center justify-content-between'>
                            <Heading as="h6" className='font-poppins'>Total Outstanding Amount</Heading>
                            <Text className='font-poppins'>₹ {(props?.data?.product_id === 1 || props?.data?.product_id === 10) ? totalEmiPayAmount : totalOutstandingAmount}</Text>
                        </Box>
                    </Box>
                    <Box mt={2} className='total_amount_box d-flex align-items-center justify-content-between'>
                        <Heading as="h6" className='font-poppins'>{(props?.data?.product_id === 1 || props?.data?.product_id === 10) ? 'EMI Due Amount' : 'Repayment Amount'}</Heading>
                        <Text className='font-poppins f-600'>₹ {totalOutstandingAmount} </Text>
                    </Box>
                </DrawerBody>
                <Box className='sidebar_footer' mb={3}>
                    {isRepaymentActive &&
                        <>
                            {pay_emi_btn == 0 ?
                                <>
                                    <Box className='full-width'>
                                        <CustomButton size="md" type="submit" isDisabled={disablePaybtn}  title={`Pay EMI (₹${EmipayoutAmnt})`} className="btn_theme_transparent font-poppins" onClick={() => props.handleOpenLoanPaymentDialog(EmipayoutAmnt)} />
                                    </Box>
                                    {forcloseActive == 1 &&
                                        <Box className='full-width' mt={2}>
                                            <CustomButton size="md" type="submit" title="Foreclose Loan" className="btn_theme_transparent font-poppins" onClick={() => props.handleforcloseDialog('for_close')} />
                                        </Box>
                                    }
                                </>
                                :
                                <>
                                    {forcloseActive == 0 ?
                                        <Box className='full-width custom-space'>
                                            <CustomButton size="md" type="submit" isDisabled={disablePaybtn} title={`Pay Now (${totalOutstandingAmount})`}  className="btn_theme_transparent font-poppins" onClick={() => props.handleOpenLoanPaymentDialog(totalOutstandingAmount)} />
                                        </Box>
                                        :
                                        <Box className='full-width' mt={2}>
                                            <CustomButton size="md" type="submit" title="Foreclose Loan" className="btn_theme_transparent font-poppins" onClick={() => props.handleforcloseDialog('for_close')} />
                                        </Box>

                                    }
                                </>
                            }
                        </>
                    }

                    {/* {
                        isPartPay && <Box className='full-width '>
                            <CustomButton isDisabled={disablePaybtn} size="md" type="submit" title="Pay Part Wise" className="btn_theme_transparent font-poppins" onClick={() => props.handleOpenPartPayDialog()} />
                        </Box>
                    } */}
                   
                        {
                        isRepaymentActive &&
                      <>
                    {
                        showParentPartial &&
                            <Box className='d-flex align-items-center justify-content-between col-gap-15 partial_popins_p' mt={5} onClick={() => handleOpenPartialDialog()}>
                            <Text className='font-poppins partial_popins' >Enter Other Amount</Text>
                            </Box>
                    }
                      </>
                        
                    }
                    {
                        showDialoagPartial &&
                        <>
                            <Input 
                            type="number"
                            name="user_enter_amount"
                            mt={3}
                            onKeyDown={(e) => {
                            if (e.key === "e" || e.key === "-") {
                                    e.preventDefault(); // Prevent ".", "e", and "-" (negative sign)
                                }
                            }}
                            onChange={(e)=>handleChange(e)}
                            value={userPartialPayment?.user_enter_amount || ""}
                            placeholder="Enter Other Amount"
                                        />

                         <Box mt={2} className='full-width'>
                         <CustomButton size="md" isDisabled ={disablePartialbtn}  type="submit" title="Pay Other Amount" mt={5} className="btn_theme_transparent font-poppins" onClick={() => props?.handleOpenLoanPaymentDialog(userPartialPayment?.user_enter_amount,showDialoagPartial)}/>

                         </Box>

                        </>
                    }
                    <Box mt={2} className='full-width'>
                        <CustomButton size="md" type="submit" title="View More" className="btn_theme font-poppins" onClick={() => props.handleViewMoreDialogOpen(loanContractId)} />
                    </Box>
                    <Box mt={2} className='full-width'>
                        <CustomButton size="md" type="submit" title="Download Agreement" className="btn_green font-poppins" onClick={() => props.handleDownloadAgreement(props.data?.esign_agreement)} />
                    </Box>
                </Box>
            </DrawerContent>
        </Box>
    )

    return (
        <Drawer
            isOpen={props.openSidebar}
            placement="right"
            onClose={props.handleCloseSidebar}
            size={'md'}
        >
            {PopupBox()}
        </Drawer>
    )
}
